module.exports = {
  address: '0x146766d444E21f3bBE3d486B1520C5a673336956',
  abi: require('./DeviceStake.abi.json'),
  '42': {
    address: '0x86EEE5BAdd22A6b98d4842142A3d18E165C52D00'
  },
  '1': {
    address: '0x146766d444E21f3bBE3d486B1520C5a673336956'
  }
}